import { useI18n } from 'core/hooks/useI18n';
import { addNoiseEventClassification } from 'app/business-logic/services/noise-service/addNoiseEventClassification';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigateToNoiseClassificationListing as useBackToListing } from '../noise-classifications-listing/useNavigateToNoiseClassificationListing';
import { QUERY_KEY } from 'app/business-logic/services/query-key';

export const useAddNoiseEventClassification = () => {
  const { l10n } = useI18n('app/views/configuration/pages/noise', 'classifications.error');
  const queryClient = useQueryClient();
  const backToListing = useBackToListing();
  const { mutate, isPending } = useMutation({
    mutationFn: addNoiseEventClassification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.noiseEventClassifications],
      });
      backToListing();
    },
    onError: (error, variables) => {
      console.error(error);
      if (window.confirm(l10n('tryAgain'))) mutate(variables);
    },
  });
  return {
    addNoiseEventClassification: mutate,
    isPending,
  };
};
